import React, { useState, useEffect } from "react";

function CountDown(props) {
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());
  function calculateTimeRemaining() {
    const endDate = new Date(props?.tenure_date);
    endDate.setHours(endDate.getHours() + parseInt(props?.nbfcTat));
    const totalSeconds = Math.round((endDate.getTime() - Date.now()) / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return { hours, minutes, seconds };
  }

  useEffect(() => {
    if (
      timeRemaining?.hours === 0 &&
      timeRemaining?.minutes === 0 &&
      timeRemaining?.seconds === 0
    ) {
      props.enableCustomerSupport();
    }

    const intervalId = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeRemaining]);

  return (
    <div>
      {timeRemaining.hours ? (
        <p>
          {timeRemaining.hours.toString().padStart(2, "0")}:
          {timeRemaining.minutes.toString().padStart(2, "0")}:
          {timeRemaining.seconds.toString().padStart(2, "0")}
        </p>
      ) : null}
    </div>
  );
}

export default CountDown;
